import { Global, css } from '@emotion/react';

import { getTinyMceStyles } from './utils/get-tinymce-styles.util';
import { getToastUiStyles } from './utils/get-toast-ui-styles.util';
import { getSocnaPrinterStyles } from './utils/get-socna-printer-styles.util';

export {
  A4_HEIGHT_MM,
  A4_WIDTH_MM,
  A3_HEIGHT_MM,
  A3_WIDTH_MM,
  PRINTER_SECTION_CLASSNAME,
  PRINTER_ORIENTATION_LANDSCAPE_CLASSNAME,
  PRINTER_ORIENTATION_PORTRAIT_CLASSNAME,
  PRINTER_FORMAT_A4_CLASSNAME,
  PRINTER_FORMAT_A3_CLASSNAME,
  PRINTER_NATIVE_PRINT_CLASSNAME,
  A4_LANDSCAPE_PAGE_BACKGROUND_URL,
  A4_PORTRAIT_PAGE_BACKGROUND_URL,
  A3_LANDSCAPE_PAGE_BACKGROUND_URL,
  A3_PORTRAIT_PAGE_BACKGROUND_URL,
  MARGIN_MM_BOTTOM,
  MARGIN_MM_LEFT,
  MARGIN_MM_RIGHT,
  MARGIN_MM_TOP,
  PAGE_BREAK_SEPARATOR_CLASSNAME,
  PAGES_BY_FORMAT_AND_ORIENTATION,
  getSocnaPrinterStyles,
} from './utils/get-socna-printer-styles.util';

// MHO : here we manage styles that are outside material-ui scope
export const GlobalStyles = () => (
  <Global
    styles={css`
      ${getTinyMceStyles()}
      ${getToastUiStyles()}
      ${getSocnaPrinterStyles()}
    `}
  />
);
